.message-container {
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: min(65%, 650px);
    align-self: flex-start;
}

.message-container--outbound {
    composes: message-container;
    align-items: flex-end;
    align-self: flex-end;
}

.message-container--with-images {
    composes: message-container;
    max-width: 450px; /* Slightly smaller to accommodate image gallery */
}

.message-container--sidebar {
    composes: message-container;
    max-width: 85%;
}

.message-container--sidebar.message-container--with-images {
    max-width: min(100%, 450px);
}

.message {
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    box-sizing: border-box;
    background-color: var(--skeleton-grey);
    color: var(--grey-dk);
    align-items: flex-start;
    width: fit-content;
    max-width: 100%;
    overflow: hidden;
    gap: 8px;
}

.message-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    font-size: var(--font-size-small);
    overflow-wrap: anywhere;
}

.message-text :global(img) {
    max-width: 100%;
    max-height: 50cqh;
}

.message--with-images {
    composes: message;
    padding: 0;
}

.message--with-images .message-text {
    padding: 8px;
    margin-top: 0;
}

.message--outbound {
    composes: message;
    background-color: var(--tag-orange-lt);
    color: var(--grey-dk);
}

.message--outbound.message--with-images {
    background-color: var(--tag-orange-lt);
    color: var(--grey-dk);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 4px 4px 0 4px;
    box-sizing: border-box;
    font-size: var(--font-size-small);
    align-items: flex-start;
    width: fit-content;
    max-width: 100%;
    overflow-wrap: anywhere;
    white-space: pre-line;
    overflow: hidden;
}

.message--outbound.message--images-only {
    background-color: var(--tag-orange-lt);
    color: var(--grey-dk);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 12px;
    box-sizing: border-box;
    font-size: var(--font-size-small);
    align-items: flex-start;
    width: fit-content;
    max-width: 100%;
    overflow-wrap: anywhere;
    white-space: pre-line;
    overflow: hidden;
}

.message--sending {
    composes: message;
    opacity: 0.7;
}

.message--scheduled {
    composes: message;
    background-color: var(--skeleton-grey);
    color: var(--grey);
}

.message--failed {
    composes: message;
    background-color: var(--white);
    color: var(--grey-lt);
    border: 1px solid var(--form-border);
}

.message--system {
    composes: message;
    background-color: var(--plum-xlt);
    color: var(--grey-dk);
}

.buttons {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: flex-end;
}

.buttons > * {
    padding: 4px 0;
}

.reaction {
    position: absolute;
    bottom: -8px;
    font-size: 12px;
    padding: 0 6px;
    border-radius: 12px;
    background-color: var(--off-white-dk);
    width: fit-content;
}

.timestamp--with-reaction-outbound {
    position: absolute;
    top: 42px;
    width: 100%;
    padding-bottom: 8px;
    margin-right: 12px;
}

.timestamp--with-reaction-inbound {
    position: absolute;
    top: 42px;
    width: 100%;
    padding-bottom: 8px;
}

.message-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
    gap: 8px;
}

.status-messages {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
    justify-content: flex-end;
}

.status-messages--without-action-buttons {
    margin-top: 4px;
    justify-content: flex-start;
}
